import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
@Component({
  selector: 'create-btn',
  template: `
  <button class="btn" (click)="goToCreate()"  *ngIf="iAllowed">
    <span>
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22.132" viewBox="0 0 22 22.132">
            <path id="ic_add_circle_outline_24px"
                d="M14.1,7.533H11.9v4.426H7.5v2.213h4.4V18.6h2.2V14.172h4.4V11.959H14.1ZM13,2A11.066,11.066,0,1,0,24,13.066,11.037,11.037,0,0,0,13,2Zm0,19.919a8.853,8.853,0,1,1,8.8-8.853A8.838,8.838,0,0,1,13,21.919Z"
                transform="translate(-2 -2)" fill="#3b8beb" />
        </svg>
    </span>
    <ng-content></ng-content>
</button>

`,
  styleUrls: ['./create-btn.component.css']
})
export class CreateBtnComponent implements OnInit {
  @Input() link;
  public iAllowed:boolean=false;

  constructor(private _route:Router,private _activeRoute:ActivatedRoute) { }

  ngOnInit() {
    let user=JSON.parse(atob(localStorage.getItem("userData")));
    if(user.userType=='ADMIN') this.iAllowed=true;
    else this.iAllowed=false;
  }

  goToCreate(){
    if(this.link)
    this._route.navigate(['create'], { relativeTo: this._activeRoute });
  }
}
